import { LOCALES } from 'src/constants';
import dayjs, { DATE_FORMATS } from 'src/locales/localizedDayjs';
import type { IDate } from 'src/interfaces';

const getDateFormat = ({ day, month, year }: IDate) => {
  const dateMasks = {
    DMY: DATE_FORMATS.FULL_DATE,
    D__: DATE_FORMATS.DAY,
    DM_: DATE_FORMATS.DAY_MONTH,
    D_Y: DATE_FORMATS.DAY_YEAR,
    _MY: DATE_FORMATS.MONTH_YEAR,
    _M_: DATE_FORMATS.MONTH,
    __Y: DATE_FORMATS.YEAR,
    ___: LOCALES.UNKNOWN,
  };
  const dateMask = [day ? 'D' : '_', month ? 'M' : '_', year ? 'Y' : '_'].join('');
  return dateMasks[dateMask as keyof typeof dateMasks] || LOCALES.UNKNOWN;
};

export const getFormattedDate = (date?: IDate) => {
  if (!date || (!date.day && !date.month && !date.year)) {
    return LOCALES.UNKNOWN;
  }

  const { day, month: originalMonth, year } = date;
  const month = originalMonth ? originalMonth - 1 : originalMonth;
  const format = getDateFormat(date);

  // @ts-ignore
  return dayjs({ year, month, day }).format(format);
};

export const checkYearIsSameOrBefore = (year: string, secondYear?: string) => {
  const currentDate = dayjs(new Date(parseInt(year, 10), 1, 1));
  const comparedDate = secondYear ? dayjs(new Date(parseInt(secondYear, 10), 1, 1)) : dayjs();

  return currentDate.isSameOrBefore(comparedDate, 'year');
};
